/* eslint-disable no-multi-str */
import React, { useState } from 'react'
import Select from 'react-select'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  User,
  FormRow,
  Button,
  AlertError,
  AlertEmpty,
  OccupationAdder
} from '../../../components'
import { Editor } from '@tinymce/tinymce-react'
import { errorHandler, formUpdater, /* inputNormalizer,  */useViewport } from '../../../utils'
import accountService from '../../../features/account/service'
import { useDispatch, useSelector } from 'react-redux'
import { FormSocial } from './form-social'
import { SystemProvider } from '../../../features/system/provider'
import { Invitations } from './content-verified-invitation'
import { JoinRequests } from './content-verified-join-requests'
import { toast } from 'react-toastify'
import { fetchAccount } from '../../../features/account/slice'
import { fetchIndividu } from '../../../features/individu/slice'
import { OccupationProvider } from '../../../features/occupation/hook/provider'
import { TINYMCE_API_KEY } from '../../../api'
import { useInternationalization } from '../../../features/i18n'

// const statusOptions = [
//   { label: 'Status 0', value: 0 },
//   { label: 'Status 1', value: 1 },
//   { label: 'Status 2', value: 2 },
// ]

const Form = ({form, setForm}) => {
  const dispatch = useDispatch()
  const [loadingEditor, setLoadingEditor] = React.useState(true)
  const [requesting, setRequesting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const { isMobile } = useViewport()
  const linkTypes = useSelector(state => state.system.linkTypes)
  const organizations = useSelector(state => state.individu.organizations)
  const { genderOptions, disabilityOptions } = useSelector(state => state.system)
  const [selectedOccupation, setSelectedOccupation] = useState([])
  const { translate } = useInternationalization()

  React.useEffect(() => {
    if(form.occupation && form.occupation.value && selectedOccupation.length === 0){
      setSelectedOccupation(form.occupation ? [form.occupation] : [])
    }
    // eslint-disable-next-line
  }, [form])

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      borderColor: '#ddd',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      paddingLeft: '1rem'
    }),
  }

  const handleEditorChange = (content, Editor) => {
    const wordcount = Editor.plugins.wordcount;
    const totalChar = wordcount.body.getCharacterCount()
    console.log({totalChar, wordcount})

    if(totalChar < 2000){
      setForm({
        ...form,
        content
      })
    } else {
      alert('Character usage has reached the limit (2000 chars).')
    }
  }

  const updateForm = (e) => formUpdater(e, form, setForm)

  const handleSubmit = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    console.log({form})

    if(form.typeAccount === 1){
      setRequesting(true)
      setErrorMessage(null)

      accountService.updateIndividu(form, form.typeAccount)
      .then(res => {
        toast.success('Successfully updated!')
        dispatch(fetchAccount())
        dispatch(fetchIndividu(form.userId))
      })
      .catch(err => {
        console.log({err})
        const msg = errorHandler(err)
        setErrorMessage(msg)
        toast.error('Error.')
      })
      .then(() => setRequesting(false))
    }
  }

  const handleGender = (e) => {
    updateForm({
      target: {
        name: 'gender',
        value: e
      }
    })
  }

  const handleDisability = (e) => {
    updateForm({
      target: {
        name: 'disability',
        value: e
      }
    })
  }

  const handleOccupation = (occupations) => {
    const newOccupations = []

    if(occupations[0]){
      newOccupations.push(occupations[0])
      updateForm({
        target: {
          name: 'occupation',
          value: occupations[0]
        }
      })
    } else {
      updateForm({
        target: {
          name: 'occupation',
          value: {}
        }
      })
    }

    setSelectedOccupation(newOccupations)
  }

  return (
    <form onSubmit={handleSubmit}>
      <p className="text-lg font-bold mb-5 lg:mb-8">{translate('GENERAL', 'profile')}</p>

      <FormRow>
        <Label>{translate('GENERAL', 'name')}</Label>
        <Input
          name="name"
          className="w-full"
          defaultValue={form.name ? form.name : ''}
          onChange={updateForm}
        />
      </FormRow>

      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        {/* <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Status</Label>
          {
            form.status &&
            <Select
              name="status"
              className="text-sm relative z-10"
              defaultValue={statusOptions.find(s => s.value === form.status)}
              options={statusOptions}
              onChange={({value}) => inputNormalizer(value, 'status', updateForm)}
            />
          }
          {
            !form.status &&
            <Select
              name="status"
              className="text-sm relative z-10"
              options={statusOptions}
              onChange={({value}) => inputNormalizer(value, 'status', updateForm)}
            />
          }
        </div> */}

        <div className={`w-full lg:w-1/2 px-4 mb-5 lg:mb-0`}>
          <div className="relative" style={{zIndex: 11}}>
            <Label>{translate('GENERAL', 'occupation')}</Label>
            <OccupationProvider>
              <OccupationAdder
                noPreview
                data={selectedOccupation}
                onChange={handleOccupation}
              />
            </OccupationProvider>
          </div>
        </div>

        <div className={`w-full ${true && 'lg:w-1/2'} px-4`}>
          <Label>{translate('GENERAL', 'i_o_c')}</Label>
          <Input
            name="institution"
            className="w-full"
            defaultValue={form.institution ? form.institution : ''}
            onChange={updateForm}
          />
        </div>
      </div>

      <FormRow>
        <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
          <div className={`w-full lg:w-1/2 px-4 mb-5 lg:mb-0`}>
            <Label>{translate('GENERAL', 'phone')}</Label>
            <Input
              name="phone"
              className="w-full"
              defaultValue={form.phone ? form.phone : ''}
              onChange={updateForm}
            />
          </div>

          <div className={`w-full lg:w-1/2 px-4`}>
            <Label>{translate('AUTH', 'email')}</Label>
            <Input
              name="email"
              type="email"
              className="w-full"
              defaultValue={form.email ? form.email : ''}
              onChange={updateForm}
            />
          </div>
        </div>
      </FormRow>

      <FormRow>
        <div className="flex flex-wrap -mx-4 relative z-10">
          <div className="w-full lg:w-1/2 px-4 ml-auto mb-4 lg:mb-0">
            <Label>{translate('GENERAL', 'disability_status')}</Label>
            <Select
              style={customStyles}
              className="text-sm"
              options={disabilityOptions}
              onChange={handleDisability}
              value={form.disability}
            />
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <Label>{translate('GENERAL', 'gender')}</Label>
            <Select
              style={customStyles}
              className="text-sm"
              options={genderOptions}
              onChange={handleGender}
              value={form.gender}
            />
          </div>
        </div>
      </FormRow>

      <div className="mb-5 lg:mb-10">
        {
          !loadingEditor &&
          <>
            <Label>{translate('GENERAL', 'about_me')}</Label>
            <p className="text-sm text-gray-444 mb-2"><em>Limit: 2000 characters</em></p>
          </>
        }
        <Editor
          apiKey={TINYMCE_API_KEY}
          initialValue={form.content ? form.content : "N/A"}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              'advlist autolink lists link charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor link | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help'
          }}
          onEditorChange={handleEditorChange}
          onInit={() => setLoadingEditor(false)}
        />
      </div>

      <hr className="my-5 lg:my-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('ORGANIZATION', 'singular')}
      </p>
      <div>
        <Label>{translate('ORGANIZATION', 'invited_by')}</Label>
        {
          (organizations && organizations.length > 0) ? (
            <div className="rounded py-5 px-4" style={{background: '#f9f9f9'}}>
              {
                organizations.map((o, index) => (
                  <div className={index < organizations.length-1 ? 'mb-4' : ''} key={o.id} id={o.id}>
                    <User name={o.name}/>
                  </div>
                ))
              }
            </div>
          ) : (
            <AlertEmpty />
          )
        }
      </div>

      <Invitations />

      <JoinRequests />

      <SystemProvider>
        {
          (linkTypes && linkTypes.length > 0) &&
          <React.Fragment>
            <hr className="my-8"/>

            <FormSocial form={form} setForm={setForm} updateForm={updateForm} />
          </React.Fragment>
        }
      </SystemProvider>

      <Button
        style={!isMobile ? {width: '197px'} : {}}
        thin={isMobile}
        disabled={requesting}
        isLoading={requesting}
      >
        <span>{translate('GENERAL', 'save')}</span>
      </Button>

      {
        errorMessage &&
        <AlertError
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      }
    </form>
  )
}

export { Form }
